import React, { useState } from "react"
import ModalCustom from "components/ModalCustom"
import alertSvg from "images/alert.svg"
import { flatMap } from "lodash"

const ModalInvite = (props) => {
  const [loading, setLoading] = useState(false)

  const save = async () => {
    setLoading(true)
    try {
      const result = await fetchGlobalApi({
        method: "POST",
        endpoint: "employees/teamleader/user/invite",
        data: {
          employees: flatMap(props.usersSelected, (item) => {
            return { id_user: item.user_id }
          }),
        },
      })
      setLoading(false)
      returnMessage(result)
      props.onFinish(true)
    } catch (error) {
      returnMessage(error)
    }
    setLoading(false)
  }

  const header = () => {
    const userSelecteds = props.usersSelected

    if (userSelecteds.length === 1) {
      return (
        <b className="component-deletesimple__title">
          ¿Estás seguro de que deseas enviar el correo de <br /> invitación a{" "}
          {userSelecteds[0].first_name} {userSelecteds[0].last_name}?
        </b>
      )
    }
    return (
      <div>
        <b className="component-deletesimple__title">
          ¿Estás seguro de que deseas enviar el correo de <br /> invitación a{" "}
          {userSelecteds.length} usuarios?
        </b>
      </div>
    )
  }

  return (
    <ModalCustom
      onCancel={() => props.onCancel()}
      onOk={save}
      modalOpen={props.open}
      showFooter
      isLoadingButton={loading}>
      <div className="component-deletesimple">
        <img src={alertSvg} className="alertIcon" />
        <div className="component-deletesimple__description">{header()}</div>
      </div>
    </ModalCustom>
  )
}

ModalInvite.defaultProps = { onCancel: () => {} }

export default ModalInvite
